import eBugReportControllerTypes from './eControllerTypes';

export default {
  EBRFCT_SPINNER: `${eBugReportControllerTypes.EBRCT_FORM}__spinner`,
  EBRFCT_FILE_DROP: `${eBugReportControllerTypes.EBRCT_FORM}__file_drop`,
}
